import { defineMessages } from 'react-intl'

const scope = `procurify.components.Budgets.SpendTrackerDepartmentCard`

export default defineMessages({
  secondaryOrgCategoryLabel: {
    id: `${scope}.secondaryOrgCategoryLabel`,
    defaultMessage: '{singularSecondaryOrgCategoryLabel}',
  },
  currentSpend: {
    id: `${scope}.currentSpend`,
    defaultMessage: 'Current spend',
  },
  currentRequest: {
    id: `${scope}.currentRequest`,
    defaultMessage: 'Current request',
  },
  spendAfterApproval: {
    id: `${scope}.spendAfterApproval`,
    defaultMessage: 'Spend after approval',
  },
  otherPendingRequests: {
    id: `${scope}.otherPendingRequests`,
    defaultMessage: 'Other pending requests',
  },
  granularSpendTableLabel: {
    id: `${scope}.granularSpendTableLabel`,
    defaultMessage: 'Granular spend',
  },

  headerToolTip: {
    id: `${scope}.headerToolTip`,
    defaultMessage:
      "This overview shows your department's year-to-date spend. It is not a custom budget.",
  },
  committedTooltipLine1: {
    id: `${scope}.subtotalsCommittedTooltipLine1`,
    defaultMessage:
      'The total amount of money that has been committed to this department.',
  },
  committedTooltipLine2: {
    id: `${scope}.subtotalsCommittedTooltipLine2`,
    defaultMessage:
      'This includes approved, purchased, received and billed amounts.',
  },
  committedLabel: {
    id: `${scope}.departmentSubtotalCommittedLabel`,
    defaultMessage: 'Committed',
  },
  requestedSpendLabel: {
    id: `${scope}.departmentSubtotalRequestedSpendLabel`,
    defaultMessage: 'This request',
  },
  totalSpendBeforePendingSpendLabel: {
    id: `${scope}.departmentSubtotalTotalSpendLabel`,
    defaultMessage: 'Total',
  },
  pendingSpendLabel: {
    id: `${scope}.pendingSpendLabel`,
    defaultMessage: 'Pending requests',
  },
  totalSpendLabel: {
    id: `${scope}.totalSpendIncludingPendingLabel`,
    defaultMessage: 'Total after pending requests',
  },
})
